import { checkIsNotEmpty } from "../rules/check-is-not-empty";
import { composeValidators } from "../compose-validators";
import { checkIsValidNumber } from "../rules/check-is-valid-number";

export const numberFieldValidator = (fieldName: string) => (value: string) => {
  const isValidNumber = () =>
    checkIsValidNumber(value) ? undefined : `Le champ ${fieldName} n'est pas un nombre valide.`;
  const isEmpty = () => (checkIsNotEmpty(value) ? undefined : `Le champ ${fieldName} est requis.`);

  return composeValidators(isEmpty, isValidNumber)(value);
};
